import React, { ReactNode, useEffect, useState } from "react";
import { Button, Input, InputProps } from "antd";
import { Loading } from "antd-mobile";
import { fail } from "assert";

const timer = Number(localStorage.getItem("SMS-CODE-CACHE"));

export function SMSCodeInputs(props: SMSCodeInputsProps) {
  const [count, setCount] = useState<number>(!isNaN(timer) ? timer : 0);
  const { onSendSmsCode, ...rest } = props;
  const [loading, setLoading] = useState<any>(false);
  // useEffect(() => {
  //   if (count > 0) {
  //     const timer = setTimeout(() => {
  //       const v = count - 1;
  //       setCount(v);
  //       localStorage.setItem("SMS-CODE-CACHE", v.toString());
  //     }, 1000);

  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   } else {
  //     setCount(0);
  //   }
  // }, [count]);

  return (
    <Input.Group compact>
      <Input style={{ width: "70%" }} {...rest} />
      {/* <Button
        disabled={Boolean(count)}
        style={{ width: "30%" }}
        type="primary"
        children={count > 0 ? count : "发送"}
        onClick={async () => {
          if (onSendSmsCode) await onSendSmsCode();
          // localStorage.setItem("SMS-CODE-CACHE", "59");
          // setCount(59);
        }}
      /> */}
      <Button
        style={{ width: "30%" }}
        type="primary"
        loading={loading}
        onClick={async () => {
          setLoading(true);
          if (onSendSmsCode) await onSendSmsCode();
          setLoading(false);
        }}
      >
        发送
      </Button>
    </Input.Group>
  );
}

export interface SMSCodeInputsProps extends InputProps {
  children?: ReactNode;
  onSendSmsCode?: () => Promise<void>;
}
